import { makeEventSchema } from './makeEventSchema';
export const stringifyEventSchema = ({ title, description, startDate, endDate, eventLocation, eventLocationName, image, url, siteUrl, }) => {
    const eventSchema = makeEventSchema({
        title: title,
        startDate: startDate,
        endDate: endDate,
        description: description,
        image: image,
        eventLocation: eventLocation,
        eventLocationName: eventLocationName,
        url: url,
        siteUrl: siteUrl,
    });
    return JSON.stringify(eventSchema, null, 2);
};
export default stringifyEventSchema;
